<div class="p-4">
  <!-- Tabs -->
  <div class="flex items-center justify-between border-b pb-2 mb-4">
    <div class="flex gap-6 font-medium">
      <p (click)="setActiveTab('orders')" [ngClass]="
          activeTab === 'orders'
            ? 'text-blue-600 border-b-2 border-blue-600'
            : 'text-gray-700'
        " class="cursor-pointer pb-1 transition-all duration-200">
        View Orders
      </p>
      <p (click)="setActiveTab('assets')" [ngClass]="
          activeTab === 'assets'
            ? 'text-blue-600 border-b-2 border-blue-600'
            : 'text-gray-700'
        " class="cursor-pointer pb-1 transition-all duration-200">
        Assets
      </p>
      <a href="/raw-material-returned-list" class="cursor-pointer pb-1 transition-all duration-200 text-gray-700">
        Returned Raw Material
      </a>
    </div>

    <!-- History Button on the Right -->
    <button (click)="setActiveTab('transactions')" [ngClass]="
        activeTab === 'transactions'
          ? 'bg-blue-600 text-white shadow-md'
          : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
      "
      class="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold transition-all active:scale-95 shadow-sm">
      <i class="fas fa-history" [ngClass]="activeTab === 'transactions' ? 'text-white' : 'text-blue-600'"></i>
      <span>History</span>
    </button>
  </div>

  <!-- Orders Section -->
  <div *ngIf="activeTab === 'orders'">
    <!-- Export Buttons for Orders -->
    <div class="flex justify-end gap-2 mb-4">
      <button (click)="printOrders()"
        class="flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 text-gray-700 rounded border hover:bg-gray-200 transition-colors text-sm font-semibold">
        <i class="fas fa-print text-blue-600"></i> Print
      </button>
      <button (click)="downloadOrdersPDF()"
        class="flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 text-gray-700 rounded border hover:bg-gray-200 transition-colors text-sm font-semibold">
        <i class="fas fa-file-pdf text-red-600"></i> PDF
      </button>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full border border-gray-300 text-sm rounded-lg overflow-hidden">
        <thead class="bg-gray-100 text-gray-700 uppercase text-xs">
          <tr>
            <th class="p-3 border border-gray-300 text-left">Order ID</th>
            <th class="p-3 border border-gray-300 text-left">Product</th>
            <th class="p-3 border border-gray-300 text-left">Product Image</th>
            <th class="p-3 border border-gray-300 text-left">Total Qty</th>
            <th class="p-3 border border-gray-300 text-left">Approved Qty</th>
            <th class="p-3 border border-gray-300 text-left">Rejected Qty</th>
            <th class="p-3 border border-gray-300 text-left">Ready Qty</th>
            <th class="p-3 border border-gray-300 text-left">Order Status</th>
            <th class="p-3 border border-gray-300 text-left">Payment Status</th>
            <th class="p-3 border border-gray-300 text-left">Return Action</th>
            <th class="p-3 border border-gray-300 text-left">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let order of orders"
            class="hover:bg-gray-50 border-b border-gray-200"
          >
            <td class="p-3 border border-gray-300">{{ order.id }}</td>
            <td class="p-3 border border-gray-300">{{ order.product_name }}</td>

            <!-- image -->
            <td class="p-3 border border-gray-300">
              <img
                [src]="order.image_url || '/assets/images/firm/firm-img.png'"
                class="w-10 h-10 object-cover rounded-md border"
              />
            </td>

            <td class="p-3 border border-gray-300">{{ order.quantity }}</td>
            <td class="p-3 border border-gray-300 text-green-700">
              {{ order.approved_quantity }}
            </td>
            <td class="p-3 border border-gray-300 text-red-600">
              {{ order.rejected_quantity }}
            </td>

            <!-- Ready Qty -->
            <td class="p-3 border border-gray-300 text-center">
              <button
                *ngIf="order.ready_quantity > 0"
                class="bg-green-100 text-green-700 px-3 py-1 rounded-lg"
                (click)="openApprovalModal(order)"
              >
                Approval Waiting {{ order.ready_quantity }}
              </button>
              <span *ngIf="order.ready_quantity <= 0" class="text-gray-400">
                —
              </span>
            </td>

            <!-- Order Status -->
            <td class="p-3 border border-gray-300">
              {{ order.status }}
            </td>

            <!-- Payment -->
            <td
              class="p-3 border border-gray-300 cursor-pointer"
              (click)="openPaymentModal(order)"
            >
              <span
                [ngClass]="{
                  'text-green-600': order.ordc_payment_status === 'Paid',
                  'text-red-600': order.ordc_payment_status === 'Unpaid'
                }"
              >
                {{ order.ordc_payment_status }}
              </span>
            </td>

            <!-- RETURN ACTION (FIXED PLACE) -->
            <td class="p-3 border border-gray-300 text-center">
              <button
                *ngIf="
                  order.request_status === 'raw_material_issue' &&
                  order.has_return_request
                "
                (click)="approveReturn(order.id)"
                class="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700"
              >
                Approve Return
              </button>

              <span *ngIf="!order.has_return_request" class="text-gray-400">
                —
              </span>
            </td>

            <!-- Date -->
            <td class="p-3 border border-gray-300">
              {{ order.created_at | date : "short" }}
            </td>
          </tr>

          <tr *ngIf="orders.length === 0">
            <td colspan="4" class="p-4 text-center text-gray-500">
              No orders found
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination for Orders -->
    <div *ngIf="totalOrders > 0"
      class="flex items-center justify-between mt-6 bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
      <div class="flex items-center gap-4">
        <div class="text-xs text-gray-500 font-medium font-sans">
          Showing <span class="text-gray-900 font-bold underline decoration-blue-200">{{ (ordersCurrentPage - 1) *
            ordersPageSize + 1 }}</span> to
          <span class="text-gray-900 font-bold underline decoration-blue-200">{{ Math.min(ordersCurrentPage *
            ordersPageSize, totalOrders) }}</span> of
          <span class="text-gray-900 font-bold">{{ totalOrders }}</span> orders
        </div>
        <!-- Per Page Selection -->
        <div class="flex items-center gap-1.5 ml-2 border-l pl-4 border-gray-200">
          <span class="text-[10px] uppercase text-gray-400 font-bold tracking-wider">Per Page</span>
          <select [(ngModel)]="ordersPageSize" (change)="onOrderPageSizeChange()"
            class="text-xs border border-gray-300 rounded px-2 py-1 bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all font-bold text-gray-700">
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="50">50</option>
            <option [value]="100">100</option>
          </select>
        </div>
      </div>
      <div class="flex items-center gap-3">
        <nav class="isolate inline-flex gap-2 -space-x-px rounded-md shadow-xs" aria-label="Pagination">
          <!-- Previous Button -->
          <button (click)="onOrderPageChange(ordersCurrentPage - 1)" [disabled]="ordersCurrentPage === 1"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-[6px] text-blue-600 ring-1 ring-blue-600 ring-inset hover:bg-blue-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all active:scale-90 bg-white shadow-sm">
            <i class="fas fa-chevron-left text-[10px]"></i>
          </button>

          <!-- Page Numbers -->
          <button *ngFor="let page of ordersPageNumbers" (click)="onOrderPageChange(page)"
            [class.bg-blue-600]="ordersCurrentPage === page" [class.text-white]="ordersCurrentPage === page"
            [class.text-blue-600]="ordersCurrentPage !== page" [class.ring-blue-600]="ordersCurrentPage === page"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-[6px] text-xs font-bold ring-1 ring-blue-100 ring-inset hover:bg-blue-50 transition-all active:scale-90 bg-white shadow-sm">
            {{ page }}
          </button>

          <!-- Next Button -->
          <button (click)="onOrderPageChange(ordersCurrentPage + 1)" [disabled]="ordersCurrentPage >= ordersLastPage"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-[6px] text-blue-600 ring-1 ring-blue-600 ring-inset hover:bg-blue-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all active:scale-90 bg-white shadow-sm disabled:bg-gray-50">
            <i class="fas fa-chevron-right text-[10px]"></i>
          </button>
        </nav>
      </div>
    </div>
  </div>

  <!-- Assets Section -->
  <div *ngIf="activeTab === 'assets'">
    <!-- <p class="text-gray-600 italic">Assets section coming soon...</p> -->
    <app-admin-assets [kalakarId]="kalakarId!"></app-admin-assets>
  </div>

  <!-- Transactions Section -->
  <div *ngIf="activeTab === 'transactions'">
    <!-- Date Filters -->
    <div class="flex flex-wrap items-center gap-4 mb-4 bg-gray-50 p-3 rounded-lg border border-gray-200 shadow-sm">
      <div class="flex flex-col">
        <label class="text-[10px] uppercase text-gray-500 font-bold mb-1">From Date</label>
        <input type="date" [(ngModel)]="fromDate" (change)="getKalakarTransactions()"
          class="text-sm border border-gray-300 rounded px-3 py-1.5 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none bg-white transition-all">
      </div>
      <div class="flex flex-col">
        <label class="text-[10px] uppercase text-gray-500 font-bold mb-1">To Date</label>
        <input type="date" [(ngModel)]="toDate" (change)="getKalakarTransactions()"
          class="text-sm border border-gray-300 rounded px-3 py-1.5 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none bg-white transition-all">
      </div>
      <div class="flex items-end h-full self-end gap-2">
        <button (click)="getKalakarTransactions()"
          class="px-5 py-1.5 bg-blue-600 text-white text-sm font-semibold rounded shadow-sm hover:bg-blue-700 hover:shadow active:scale-95 transition-all">
          Apply Filter
        </button>
        <button (click)="clearTransactionsFilter()"
          class="px-5 py-1.5 bg-gray-200 text-gray-700 text-sm font-semibold rounded shadow-sm hover:bg-gray-300 active:scale-95 transition-all">
          Clear
        </button>
      </div>

      <!-- Export Buttons for Transactions -->
      <div class="flex items-end h-full self-end gap-2 ml-auto">
        <button (click)="printTransactions()"
          class="flex items-center gap-1.5 px-3 py-1.5 bg-white text-gray-700 rounded border hover:bg-gray-50 transition-colors text-sm font-semibold shadow-sm">
          <i class="fas fa-print text-blue-600"></i> Print
        </button>
        <button (click)="downloadTransactionsPDF()"
          class="flex items-center gap-1.5 px-3 py-1.5 bg-white text-gray-700 rounded border hover:bg-gray-50 transition-colors text-sm font-semibold shadow-sm">
          <i class="fas fa-file-pdf text-red-600"></i> PDF
        </button>
      </div>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full border border-gray-300 text-sm rounded-lg overflow-hidden shadow-sm">
        <thead class="bg-gray-100 text-gray-700 uppercase text-[10px] font-bold tracking-wider">
          <tr>
            <th class="p-3 border border-gray-300 text-left">Date</th>
            <th class="p-3 border border-gray-300 text-left">Type</th>
            <th class="p-3 border border-gray-300 text-left">Code</th>
            <th class="p-3 border border-gray-300 text-left">Product Name</th>
            <th class="p-3 border border-gray-300 text-left">Quantity</th>
            <th class="p-3 border border-gray-300 text-left">Amount</th>
            <th class="p-3 border border-gray-300 text-left">Remarks</th>
            <th class="p-3 border border-gray-300 text-left">Admin</th>
          </tr>
        </thead>
        <tbody class="text-gray-600">
          <tr *ngFor="let tx of transactions" class="hover:bg-blue-50/30 border-b border-gray-200 transition-colors">
            <td class="p-3 border border-gray-300 font-medium text-gray-900">
              {{ tx.created_at | date: 'dd-MMMM-yyyy hh:mm a' }}
            </td>
            <td class="p-3 border border-gray-300">
              <span [ngClass]="{
                'text-blue-700': tx.ot_type === 'order_assigned',
                'text-orange-700': tx.ot_type === 'stock_handed_over',
                'text-green-700': tx.ot_type === 'quantity_approved',
                'text-red-700': tx.ot_type === 'quantity_rejected',
                'text-emerald-700': tx.ot_type === 'labour_paid',
                'text-amber-700': tx.ot_type === 'return_requested',
                'text-yellow-700': tx.ot_type === 'submitted_for_approval',
                'text-indigo-700': tx.ot_type === 'return_approved'
              }" class="font-bold uppercase tracking-tight text-[10px]">
                {{ formatTransactionType(tx.ot_type) }}
              </span>
            </td>
            <td
              class="p-3 border border-gray-300 font-mono text-xs uppercase tracking-tighter text-blue-600 font-semibold">
              {{ tx.ot_product_code }}
            </td>
            <td class="p-3 border border-gray-300">
              {{ tx.ot_product_name }}
            </td>
            <td class="p-3 border border-gray-300 font-semibold">
              {{ tx.ot_quantity }}
            </td>
            <td class="p-3 border border-gray-300">
              <span *ngIf="tx.ot_amount > 0" class="text-green-700 font-bold">₹ {{ tx.ot_amount }}</span>
              <span *ngIf="!tx.ot_amount || tx.ot_amount <= 0" class="text-gray-400">—</span>
            </td>
            <td class="p-3 border border-gray-300 italic text-gray-500 max-w-xs truncate" [title]="tx.ot_remarks"
              [innerHTML]="getColorizedRemark(tx.ot_remarks)">
            </td>
            <td class="p-3 border border-gray-300 font-medium">
              {{ tx.createdBy?.name || '—' }}
            </td>
          </tr>
          <tr *ngIf="!isLoadingTransactions && transactions.length === 0">
            <td colspan="8" class="p-8 text-center text-gray-500 bg-gray-50 font-medium italic">No transactions found
              for the selected period</td>
          </tr>
          <tr *ngIf="isLoadingTransactions">
            <td colspan="8" class="p-12 text-center bg-gray-50">
              <div class="flex justify-center items-center flex-col gap-3">
                <div class="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                <span class="text-sm text-blue-600 font-semibold animate-pulse uppercase tracking-widest">Fetching
                  Transactions...</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="totalTransactions > 0"
      class="flex items-center justify-between mt-6 bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
      <div class="flex items-center gap-4">
        <div class="text-xs text-gray-500 font-medium font-sans">
          Showing <span class="text-gray-900 font-bold underline decoration-blue-200">{{ (currentPage - 1) * pageSize +
            1
            }}</span> to
          <span class="text-gray-900 font-bold underline decoration-blue-200">{{ Math.min(currentPage * pageSize,
            totalTransactions) }}</span> of
          <span class="text-gray-900 font-bold">{{ totalTransactions }}</span> transactions
        </div>
        <!-- Per Page Selection -->
        <div class="flex items-center gap-1.5 ml-2 border-l pl-4 border-gray-200">
          <span class="text-[10px] uppercase text-gray-400 font-bold tracking-wider">Per Page</span>
          <select [(ngModel)]="pageSize" (change)="onPageSizeChange()"
            class="text-xs border border-gray-300 rounded px-2 py-1 bg-gray-50 outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all font-bold text-gray-700">
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="50">50</option>
            <option [value]="100">100</option>
          </select>
        </div>
      </div>
      <div class="flex items-center gap-3">
        <nav class="isolate inline-flex gap-2 -space-x-px rounded-md shadow-xs" aria-label="Pagination">
          <!-- Previous Button -->
          <button (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-[6px] text-blue-600 ring-1 ring-blue-600 ring-inset hover:bg-blue-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all active:scale-90 bg-white shadow-sm">
            <i class="fas fa-chevron-left text-[10px]"></i>
          </button>

          <!-- Page Numbers -->
          <button *ngFor="let page of txPageNumbers" (click)="onPageChange(page)"
            [class.bg-blue-600]="currentPage === page" [class.text-white]="currentPage === page"
            [class.text-blue-600]="currentPage !== page" [class.ring-blue-600]="currentPage === page"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-[6px] text-xs font-bold ring-1 ring-blue-100 ring-inset hover:bg-blue-50 transition-all active:scale-90 bg-white shadow-sm">
            {{ page }}
          </button>

          <!-- Next Button -->
          <button (click)="onPageChange(currentPage + 1)" [disabled]="currentPage >= lastPage"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-[6px] text-blue-600 ring-1 ring-blue-600 ring-inset hover:bg-blue-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all active:scale-90 bg-white shadow-sm disabled:bg-gray-50">
            <i class="fas fa-chevron-right text-[10px]"></i>
          </button>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Approval Modal -->
<div *ngIf="showApprovalModal"
  class="fixed inset-0 z-50 flex justify-center items-center bg-black/30 backdrop-blur-sm transition-opacity duration-300 ease-in-out">
  <div
    class="bg-white/95 p-8 rounded-2xl shadow-2xl w-[95%] max-w-lg m-4 transform transition-all duration-500 ease-out scale-95 animate-fade-in-up border border-gray-100">
    <!-- Header -->
    <h2 class="text-2xl font-semibold mb-4 text-center text-gray-900">
      Approve Ready Quantity
    </h2>

    <!-- Order Info -->
    <div class="bg-gray-50 p-4 rounded-lg mb-6 border border-gray-200 shadow-inner text-sm">
      <div class="flex justify-between mb-2">
        <span class="text-gray-600">Product Name:</span>
        <strong>{{ selectedOrder?.product_name }} ({{
          selectedOrder?.product_code
          }})</strong>
      </div>
      <div class="flex justify-between text-gray-600">
        <span>Ready Quantity:</span>
        <strong class="text-gray-800">{{
          selectedOrder?.ready_quantity
          }}</strong>
      </div>
    </div>

    <!-- Quantity Input -->
    <div class="mb-6">
      <label for="approvedQty" class="block text-sm font-medium text-gray-700 mb-2">
        Enter Approved Quantity:
      </label>
      <input type="number" id="approvedQty" [(ngModel)]="approvedQty" [max]="selectedOrder?.ready_quantity" min="0"
        class="no-spinner border border-gray-300 rounded-lg px-4 py-3 w-full shadow-sm focus:outline-none focus:ring-[#c19725] focus:border-[#c19725] transition-all duration-200"
        placeholder="Enter approved quantity" />
    </div>

    <!-- Action Buttons -->
    <div class="flex justify-end gap-4">
      <button (click)="closeApprovalModal()"
        class="px-5 py-2.5 rounded-lg bg-gray-200 text-gray-800 hover:bg-gray-300 transition-all duration-300">
        Cancel
      </button>
      <button (click)="approveQuantity()"
        class="px-5 py-2.5 rounded-lg bg-[#c19725] text-white hover:bg-[#a87f1f] shadow-md hover:scale-105 transition-all duration-300">
        Approve
      </button>
    </div>
  </div>
</div>